/**
 * Địa bàn in theo tổng hợp
 * pdtai 16.07.2024
 */
export default {
  DistrictAndCommune: 0, // Toàn huyện
  District: 1, // Ngân sách huyện
  Commune: 2 // Ngân sách xã
};